import { ImgHTMLAttributes } from 'react'

export function Image(
  props: ImgHTMLAttributes<HTMLImageElement>
) {
  return (
    <img
      loading="lazy"
      // loader={({ src, width, quality }) => {
      //   return db.storage
      //     .from('public-profiles')
      //     .getPublicUrl(src.replace(/^\//, ''), {
      //       // Free plan doesn't support transform
      //       // transform: {
      //       //   width,
      //       //   resize: 'contain',
      //       // },
      //     }).data.publicUrl
      // }}
      {...props}
      src={props.src}
    />
  )
}
